'use client';

import { useOnboardingState } from '@/src/lib/onboarding/use-onboarding-state';

/**
 * Experienced-Toggle: blendet alle Touren und Wizards dauerhaft aus.
 * Wird im User-Menü angezeigt, damit Power-User sie bewusst deaktivieren können.
 */
export function ExperiencedToggle() {
  const { state, setExperienced, isReady } = useOnboardingState();
  const experienced = state.experienced;

  if (!isReady) return null;

  return (
    <label className="flex cursor-pointer items-center justify-between gap-3 rounded-[var(--k-radius-sm)] px-3 py-2 text-sm font-medium text-[var(--k-color-text-secondary)] transition hover:bg-[var(--k-color-surface-muted)] hover:text-[var(--k-color-text-primary)]">
      <span className="flex items-center gap-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="9" />
          <path d="M12 8v4l3 2" />
        </svg>
        Erweiterte Ansicht
      </span>
      <span
        className={`relative inline-flex h-5 w-9 items-center rounded-full transition ${
          experienced ? 'bg-[var(--k-color-accent)]' : 'bg-[var(--k-color-border-default)]'
        }`}
        aria-hidden="true"
      >
        <span
          className={`inline-block h-3.5 w-3.5 transform rounded-full bg-[var(--k-color-surface)] shadow-sm transition ${
            experienced ? 'translate-x-4' : 'translate-x-1'
          }`}
        />
      </span>
      <input
        type="checkbox"
        checked={experienced}
        onChange={(e) => setExperienced(e.target.checked)}
        className="sr-only"
        aria-label="Erweiterte Ansicht – Touren und Wizards dauerhaft ausblenden"
      />
    </label>
  );
}
